import { FooterLink } from "./FooterLink";

export { FooterLink };
